// extracted by mini-css-extract-plugin
export default {"dropdownLabel":"SearchPageStyles_dropdownLabel__xAq2M","yearFilter":"SearchPageStyles_yearFilter__zceXG","statusFilter":"SearchPageStyles_statusFilter__ivsIU"};